import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, CalendarDays } from "lucide-react";
import { TeaserCard } from "@/components/TeaserCard";
import { CoincidenceEngine } from "@/components/CoincidenceEngine";
import { CurioVaultCard } from "@/components/CurioVaultCard";
import { BirthdayLink } from "@/components/BirthdayCaptureModal";

export const TeaserCards = ({ events, ddmm, onToday }) => {
  const navigate = useNavigate();
  return (
  <div data-testid="teaser-cards" className="my-6 md:my-8 flex items-stretch md:grid md:grid-cols-2 lg:grid-cols-4 md:auto-rows-fr gap-3 md:gap-4 overflow-x-auto md:overflow-visible snap-x snap-mandatory -mx-4 px-4 md:mx-0 md:px-0 pb-2 md:pb-0 scrollbar-none [&>*]:min-w-[84%] [&>*]:snap-start md:[&>*]:min-w-0">
    <TeaserCard icon={Sparkles} title="Daily Horoscope" testid="value-pillar-daily-horoscope" cta="Read today's horoscope →" ctaTestid="teaser-horoscope-cta" onCta={() => navigate("/horoscope")} extra={<BirthdayLink testid="birthday-link-teaser" className="mt-2 self-start" source="teaser_card" />}>
      Personal guidance for your zodiac, not generic. Energy, love, career.
    </TeaserCard>
    <TeaserCard icon={CalendarDays} title="On This Day" testid="value-pillar-on-this-day" cta="See today's events →" ctaTestid="teaser-today-cta" onCta={onToday}>
      Real, verified events that share your birthday. Dozens of events per day searchable.
    </TeaserCard>
    <CoincidenceEngine events={events} ddmm={ddmm} />
    <CurioVaultCard />
  </div>
  );
};

export const WhyStrip = () => (
  <section id="why-oddlytrue" data-testid="value-section" className="mt-12 border-t border-[#e5e7eb] bg-paper">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center">
      <h2 className="text-base md:text-lg font-semibold text-ink tracking-tight">Why 2 million people will check OddlyTrue every morning</h2>
      <p className="mt-2 text-sm text-ink-muted">Learn, laugh, connect with history. Free daily email 7am. 1,000s of searchable events.</p>
    </div>
  </section>
);
